import React, { useEffect, useId } from "react";
import { createPortal } from "react-dom";
import { normalizeToolPrepHowToUse } from "../../../../config/tools/toolPrepHowToUseCatalog";
import "./ToolPrepHowToUseModal.css";

export {
  normalizeToolPrepHowToUse,
  buildToolPrepHowToUse,
  getToolPrepHowToUse,
  resolveToolPrepHowToUse,
} from "../../../../config/tools/toolPrepHowToUseCatalog";

/**
 * Compact help dialog: short intro + steps + tip.
 */
const ToolPrepHowToUseModal = ({
  open = false,
  title = "How to use",
  howToUse = null,
  onClose = () => {},
}) => {
  const titleId = useId();
  const content = normalizeToolPrepHowToUse(howToUse);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !content || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="tp-howto"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
    >
      <div
        className="tp-howto__panel"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="tp-howto__header">
          <h3 id={titleId} className="tp-howto__title">
            {title}
          </h3>
          <button
            type="button"
            className="tp-howto__close"
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              viewBox="0 0 14 14"
              width="14"
              height="14"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M1 1l12 12M13 1L1 13"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="tp-howto__body">
          {content.aka ? (
            <p className="tp-howto__aka">
              Also known as <span>{content.aka}</span>
            </p>
          ) : null}
          {content.summary ? (
            <p className="tp-howto__summary">{content.summary}</p>
          ) : null}

          {content.steps.length ? (
            <div className="tp-howto__section">
              <p className="tp-howto__section-label">How to use</p>
              <ol className="tp-howto__steps">
                {content.steps.map((step, index) => (
                  <li key={`${index}-${step}`}>{step}</li>
                ))}
              </ol>
            </div>
          ) : null}

          {content.tip ? (
            <div className="tp-howto__tip">
              <p className="tp-howto__section-label">Tip</p>
              <p className="tp-howto__tip-text">{content.tip}</p>
            </div>
          ) : null}
        </div>

        <div className="tp-howto__footer">
          <button type="button" className="tp-howto__done" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ToolPrepHowToUseModal;
